import { getAmplitudeInstance } from '../amplitudeHelpers';

type logMultiDayRouteSegmentListViewedParams = {
  segment_count?: number;
  trail_id: number;
};

/**
 * User scrolls the 'Route segments' section of a multi-day route trail details page into view. Fires once per section impression, not per card.
 * @param params - Attributes to log with the amplitude event
 * @param params.segment_count - Number of segments listed in the section.
 * @param params.trail_id - The trail id of the multi-day route trail details page.
 */
const logMultiDayRouteSegmentListViewed = ({ segment_count, trail_id }: logMultiDayRouteSegmentListViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('multi day route segment list viewed', { 'segment count': segment_count, 'trail id': trail_id }, callback);
};

export default logMultiDayRouteSegmentListViewed;
